/**
 * Shop By Refill Category carousel. v1.3.1
 * Desktop: 5 visible, auto-advance, side chevrons.
 * Mobile: 3 visible, finger swipe, setInterval autoplay (matches sfs-hero-slideshow.js).
 * Case: autoplay must not depend on IntersectionObserver; legacy head CSS unrelated.
 * Case: v1.3.1 wait for a swipe threshold before capturing pointer so tile
 * filter links still navigate on a click.
 */
(function () {
  var MQ = window.matchMedia('(min-width: 750px)');

  /**
   * Reads visible tile count from section CSS (--sfs-sc-visible).
   * @param {HTMLElement} root
   * @returns {number}
   */
  function visibleCount(root) {
    var count = parseInt(window.getComputedStyle(root).getPropertyValue('--sfs-sc-visible'), 10);
    if (count > 0) return count;
    return MQ.matches ? 5 : 3;
  }

  /**
   * Initializes one carousel root.
   * @param {HTMLElement} root
   */
  function initCarousel(root) {
    if (!root || root.getAttribute('data-sfs-sc-ready') === 'true') return;

    var viewport = root.querySelector('[data-sfs-sc-viewport]');
    var track = root.querySelector('[data-sfs-sc-track]');
    var prevBtn = root.querySelector('[data-sfs-sc-prev]');
    var nextBtn = root.querySelector('[data-sfs-sc-next]');
    if (!viewport || !track) return;

    var originals = Array.prototype.slice.call(track.children);
    if (originals.length === 0) return;

    root.setAttribute('data-sfs-sc-ready', 'true');

    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var pauseMs = parseInt(root.getAttribute('data-pause-ms') || '2000', 10);
    var animMs = parseInt(root.getAttribute('data-anim-ms') || '550', 10);

    var index = 0;
    var timer = null;
    var animating = false;
    var dragging = false;
    var dragArmed = false;
    var suppressClick = false;
    var startX = 0;
    var deltaX = 0;
    var baseX = 0;
    var itemWidth = 0;
    var gap = 0;
    var swipeThreshold = 8;

    originals.forEach(function (node) {
      var clone = node.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.tabIndex = -1;
      track.appendChild(clone);
    });

    /**
     * Measures tile width and gap from layout.
     */
    function measure() {
      var first = track.children[0];
      if (!first) return;
      var styles = window.getComputedStyle(track);
      gap = parseFloat(styles.columnGap || styles.gap) || 0;
      itemWidth = first.getBoundingClientRect().width;
    }

    /**
     * Applies translate for the current index.
     * @param {boolean} [animate]
     */
    function applyTransform(animate) {
      if (!itemWidth) return;
      if (!animate) track.classList.add('is-dragging');
      else track.classList.remove('is-dragging');
      var x = -(index * (itemWidth + gap));
      track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
      if (!animate) {
        track.offsetHeight;
        track.classList.remove('is-dragging');
      }
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

  /**
   * Starts autoplay interval (hero slideshow pattern).
   */
    function startAutoplay() {
      stopAutoplay();
      if (!autoplay) return;
      if (originals.length <= visibleCount(root)) return;
      timer = window.setInterval(function () {
        if (animating || dragging) return;
        next();
      }, pauseMs + animMs);
    }

    function finishStep(afterWrap) {
      window.setTimeout(function () {
        if (typeof afterWrap === 'function') afterWrap();
        animating = false;
      }, animMs);
    }

    function next() {
      if (animating || dragging || originals.length <= visibleCount(root)) return;
      if (!itemWidth) {
        measure();
        if (!itemWidth) return;
      }
      animating = true;
      index += 1;
      applyTransform(true);
      finishStep(function () {
        if (index >= originals.length) {
          index = 0;
          applyTransform(false);
        }
      });
    }

    function prev() {
      if (animating || dragging || originals.length <= visibleCount(root)) return;
      if (!itemWidth) {
        measure();
        if (!itemWidth) return;
      }
      animating = true;
      if (index <= 0) {
        index = originals.length;
        applyTransform(false);
        track.offsetHeight;
      }
      index -= 1;
      applyTransform(true);
      finishStep();
    }

    function layout() {
      measure();
      if (index >= originals.length) index = 0;
      applyTransform(false);
    }

    function onResize() {
      layout();
    }

    function onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      stopAutoplay();
      dragArmed = true;
      dragging = false;
      suppressClick = false;
      startX = event.clientX;
      deltaX = 0;
      if (!itemWidth) measure();
      baseX = -(index * (itemWidth + gap));
    }

    function onPointerMove(event) {
      if (!dragArmed && !dragging) return;
      deltaX = event.clientX - startX;
      if (!dragging && Math.abs(deltaX) > swipeThreshold) {
        dragging = true;
        track.classList.add('is-dragging');
        try {
          viewport.setPointerCapture(event.pointerId);
        } catch (err) {}
      }
      if (!dragging) return;
      track.style.transform = 'translate3d(' + (baseX + deltaX) + 'px, 0, 0)';
    }

    function onPointerUp(event) {
      if (!dragArmed && !dragging) return;
      var wasDragging = dragging;
      dragArmed = false;
      dragging = false;
      track.classList.remove('is-dragging');
      try {
        viewport.releasePointerCapture(event.pointerId);
      } catch (err) {}

      if (!wasDragging) {
        startAutoplay();
        return;
      }

      suppressClick = true;
      var threshold = Math.max(40, itemWidth * 0.18);
      if (deltaX <= -threshold) index += 1;
      else if (deltaX >= threshold) index -= 1;

      if (index < 0) index = originals.length - 1;
      if (index >= originals.length) {
        applyTransform(true);
        finishStep(function () {
          index = 0;
          applyTransform(false);
          startAutoplay();
        });
        return;
      }

      applyTransform(true);
      finishStep(function () {
        startAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (event) {
        event.preventDefault();
        stopAutoplay();
        prev();
        startAutoplay();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (event) {
        event.preventDefault();
        stopAutoplay();
        next();
        startAutoplay();
      });
    }

    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove);
    viewport.addEventListener('pointerup', onPointerUp);
    viewport.addEventListener('pointercancel', onPointerUp);

    viewport.addEventListener(
      'click',
      function (event) {
        if (suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          suppressClick = false;
        }
        deltaX = 0;
      },
      true
    );

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });

    if (typeof MQ.addEventListener === 'function') {
      MQ.addEventListener('change', function () {
        layout();
        startAutoplay();
      });
    } else if (typeof MQ.addListener === 'function') {
      MQ.addListener(function () {
        layout();
        startAutoplay();
      });
    }

    window.addEventListener('resize', onResize);
    window.addEventListener('load', function () {
      layout();
      startAutoplay();
    });

    layout();
    window.requestAnimationFrame(function () {
      layout();
      startAutoplay();
    });
  }

  function boot(scope) {
    var roots = scope && scope.querySelectorAll
      ? scope.querySelectorAll('[data-sfs-shop-cat]')
      : document.querySelectorAll('[data-sfs-shop-cat]');
    roots.forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
